'use client';

import { Combobox } from '@holistic/components';

import type { CargoLocation } from '@/types/cargo';

type CargoLocationSelectProps = {
  label: string;
  placeholder: string;
  /** Üst seviye seçilmediği için kapalıyken gösterilen metin. */
  lockedText: string;
  options: CargoLocation[] | undefined;
  value: CargoLocation | null;
  isLoading: boolean;
  /** Üst seviye henüz seçilmedi: liste hiç istenmez, alan kilitli kalır. */
  isLocked: boolean;
  optional?: boolean;
  error?: string;
  onSelect: (location: CargoLocation | null) => void;
};

/**
 * Cascade adres seçicisinin tek bir seviyesi (il / ilçe / semt).
 *
 * Combobox `value` olarak string taşıdığı için id'ler string'e çevrilir; dışarı
 * ise seçilen kaydın kendisi verilir — talep gövdesine `name` birebir yazılacağı
 * için ad, bir sonraki seviyeyi çağırmak için de id gerekiyor.
 */
const CargoLocationSelect = ({
  label,
  placeholder,
  lockedText,
  options,
  value,
  isLoading,
  isLocked,
  optional,
  error,
  onSelect,
}: CargoLocationSelectProps) => {
  const items = options ?? [];

  return (
    <div className="flex flex-col gap-2">
      <label className="text-sm font-medium text-gray-700">
        {label}
        {optional && <span className="text-gray-400"> (opsiyonel)</span>}
      </label>

      <Combobox
        value={value ? String(value.id) : ''}
        options={items.map((item) => ({
          value: String(item.id),
          label: item.name,
        }))}
        onValueChange={(next) => {
          const id = Array.isArray(next) ? next[0] : next;
          onSelect(items.find((item) => String(item.id) === id) ?? null);
        }}
        placeholder={isLocked ? lockedText : placeholder}
        searchable
        searchPlaceholder="Ara..."
        emptyText={isLoading ? 'Yükleniyor...' : 'Sonuç bulunamadı'}
        disabled={isLocked}
        loading={isLoading}
        clearable
        error={error}
        triggerClassName="w-full"
      />
    </div>
  );
};

export default CargoLocationSelect;
